export const isSuperAdmin = (roleIds: number[]) => {
  return roleIds.some((roleId) => roleId === 100);
};
